import { mapState, mapActions } from '@/store/helpers';

//  handle some needs and search bar  common need logic 
import { getFilterType } from '../api';

import {
    LISTING_SOURCE_MUTATION,
    SET_LISTING_SOURCE_READY
} from '../_store/config';

export default {
    computed: {

        ...mapState({
            "listingSourceReady": store => store.listingSourceReady
        }),
        
    },
    methods: {

        ...mapActions({
            "listingSourceMutation": LISTING_SOURCE_MUTATION,
            "setListingSourceReady": SET_LISTING_SOURCE_READY
        }),
        
        setListingSource(listingSource, resolve) {
            this.listingSourceMutation(listingSource);
            this.setListingSourceReady(true);
            resolve();
        },
        getListingSource(query) {
            return new Promise((resolve, reject) => {
                if (this.listingSourceReady) {
                    return resolve();
                }
                // snapshot middle listing source for sold listing
                if (this.listingSourceOut) {
                    return this.setListingSource(
                        this.listingSourceOut,
                        resolve
                    );
                }
                if (this.hideSearch) {
                    return this.setListingSource('sold listings', resolve);
                }
                let listingSource =
                    query.listingSource || query.featureListingName;
                if (listingSource) {
                    let reg = /^\d\+/;
                    if (
                        reg.test(listingSource) ||
                        [
                            'all listings',
                            'sold listings',
                            'rental listings',
                            'only my listings',
                            'only team listings',
                            'single property promotion'
                        ].indexOf(listingSource.toLowerCase()) !== -1
                    ) {
                        this.setListingSource(listingSource, resolve);
                    } else {
                        return getFilterType.call(this, {
                            name: listingSource
                        }).then(data => {
                            this.setListingSource(
                                    `${data.listingType}+${listingSource}`,
                                    resolve
                            );
                        })
                            .catch(err => {
                                reject(err);
                            });
                    }
                } else {
                    this.setListingSource(this.listingSource, resolve);
                }
            });
        }
    }
};
